module.exports = __webpack_public_path__ + "img/mira-horizontal.a56d49fb.svg";